import { Skeleton, styled } from '@mui/material';
import { TrackPlayback } from '../TrackGrid';

export const StyledTrackPlayback = styled(TrackPlayback)(() => ({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const StyledPlaybackSkeleton = styled(Skeleton)(({ theme }) => ({
  margin: 'auto',
  height: 'auto',
  aspectRatio: '1 / 1',
  [theme.breakpoints.down('md')]: {
    width: theme.spacing(4.5),
  },
  [theme.breakpoints.down('lg')]: {
    width: '100%',
  },
}));

StyledPlaybackSkeleton.defaultProps = {
  variant: 'circular',
};

export const StyledTitleSkeleton = styled(Skeleton)(({ theme }) => ({
  width: '100%',
  maxWidth: theme.spacing(15.25),
}));

StyledTitleSkeleton.defaultProps = {
  variant: 'rectangular',
};

export const StyledDurationSkeleton = styled(Skeleton)(({ theme }) => ({
  maxWidth: theme.spacing(4),
  [theme.breakpoints.down('xs')]: {
    display: 'none',
  },
}));

StyledDurationSkeleton.defaultProps = {
  variant: 'rectangular',
};
